import React from "react";
import { Facebook } from "lucide-react";
import { SOCIALS } from "@/lib/api";

export const TikTokIcon = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M16.6 5.82a4.28 4.28 0 0 1-1.06-2.82h-3.2v12.1a2.4 2.4 0 1 1-2.4-2.4c.2 0 .4.03.6.08V7.5a5.6 5.6 0 1 0 5 5.57V8.4a7.4 7.4 0 0 0 4.3 1.37V6.54a4.28 4.28 0 0 1-3.24-.72z" />
  </svg>
);

export const SocialLinks = ({ tileClass = "", iconClass = "h-4 w-4" }) => (
  <div className="flex gap-3">
    <a
      href={SOCIALS.tiktok}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="social-tiktok"
      aria-label="TikTok"
      className={tileClass}
    >
      <TikTokIcon className={iconClass} />
    </a>
    <a
      href={SOCIALS.facebook}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="social-facebook"
      aria-label="Facebook"
      className={tileClass}
    >
      <Facebook className={iconClass} />
    </a>
  </div>
);
